module.exports = __webpack_public_path__ + "img/Master-1.4d1272ad.png";